import React from 'react';
import useSearchParams from './hooks.useSearchParams';
import useIntl from '../../hooks/useIntl';

import {
  Banner,
  Grid,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { AlertIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

import messages from './messages';

const AffordableTransferBanner = ({ HUDTransferProps }) => {
  const { isTransfer } = useSearchParams();

  const intl = useIntl();

  const showHudMultipleSubsidiesBanner =
    (HUDTransferProps?.hasMultipleHUDSubsidies ?? false) &&
    !(HUDTransferProps?.isLoading ?? false) &&
    isTransfer;

  return (
    <Grid container fluid spacing={1}>
      {showHudMultipleSubsidiesBanner && (
        <Grid item xs={12}>
          <Banner
            color={'lightGrey'}
            TypographyProps={{
              noWrap: false,
            }}
            hasBorder={false}
            text={
              intl?.formatMessage(messages.affordableTransferBanner) ??
              messages.affordableTransferBanner.defaultMessage
            }
            icon={<AlertIcon />}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default AffordableTransferBanner;
